import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export class ClientsModel {

  address_1: string;
  address_2: string;
  reference_no: string;
  email: string;
  first_name: string;
  id: number;
  last_name: string;
  phone_mobile: string;
  post_code: string;
  phone_number: number;
  vat_no: number;
  company_name: string;

  constructor(input?) {
    input = input || {};
    this.id = input.id || '';
	this.reference_no = input.reference_no || '';
    this.first_name = input.first_name || '';
    this.last_name = input.last_name || '';
    this.email = input.email || '';
    this.post_code = input.post_code || '';
    this.phone_mobile = input.phone_mobile || '';
    this.address_2 = input.address_2 || '';
    this.address_1 = input.address_1 || '';
    this.phone_number = input.phone_number || '';
	this.vat_no = input.vat_no || '';
	this.company_name = input.company_name || '';

  }

  static getFormGroup(input): FormGroup {
    let fb: FormBuilder = new FormBuilder();
    return fb.group({
	  reference_no: [input.reference_no, Validators.required],
      first_name: [input.first_name, Validators.required],
      last_name: [input.last_name, Validators.required],
      email: [input.email, Validators.required],
      password: [input.password],
      password_confirmation: [input.password_confirmation],
      address_1: [input.address_1],
      address_2: [input.address_2],
      post_code: [input.post_code],
      phone_mobile: [input.phone_mobile],
      vat_no:[input.vat_no],
	  phone_number:[input.phone_number],
	  company_name:[input.company_name]
    })
  }

  static getListRow(row:ClientsModel) {
    return {
      id: row.id,
      name: row.first_name + ' ' + row.last_name,
      email: row.email
    };
  }

}